import React from 'react';
import CustomModal from "../../../../components/Modal/CustomModal";
import {
    FileTracking, IconCardFillMonitor
} from "../../../../components/buttons/IconButtons";
import {DeviceLogModalApp} from "../Funtionality/DeviceLogModalApp";
import CustomTable from "../../../../components/table/CustomTable";
import CustomCard from "../../../../components/CustomCard";

/**
 * Displays the device log history inside a modal window.
 *
 * This component renders:
 * - Device information header.
 * - Paginated device logs table.
 * - Device log modal layout.
 *
 * @component DeviceLogModal
 *
 * @param {Object} props - Component properties.
 * @param {Object} props.data - Device information object.
 * @param {number|string} props.data.id - Device identifier.
 * @param {string} props.data.name - Device name.
 *
 * @returns {JSX.Element} Device log modal component.
 */
const DeviceLogModal = (props) => {

    const {data} = props;
    const {
        pagination,
        t,
        tableId,
        thead,
        tbody
    } = DeviceLogModalApp({data})

    return (

            <CustomModal
                {...props}
                size="lg"
                buttonConfirm="confirm"
                cancelButton={false}
                confirmButton={false}
                topLeftHeader={
                    <div className='d-flex align-items-center'>
                        <FileTracking />
                        <p className='fs-24px ibl-font-w-600  font-color-general-950 font-color-primary-600 ml-2'>
                            {t('device_log')}
                        </p>
                        <div className='vertical-separator h-auto' />
                    </div>
                }
                classNameBody="pt-2"
            >
                <CustomCard classes="card-border-8px" classContent="p-0 overflow-hidden">
                    <div className="d-flex align-items-center p-3">
                        <div><IconCardFillMonitor /></div>
                        <div className="ml-2">
                            <p className="font-color-general-950 ibl-font-w-600 fs-14px">{data?.name}</p>
                        </div>
                    </div>
                    <div className="border-bottom-shades-300" />
                    <CustomTable tableId={tableId}
                                 thead={thead}
                                 tbody={tbody}
                                 textNotInformation={"no_information"}
                                 columnActions={false}
                                 inModal={true}
                    />
                    {pagination()}
                </CustomCard>
            </CustomModal>
    );
};

export default DeviceLogModal;
